
      // Studio privacy-first analytics: first-party, cookieless, no stored IP.
      try {
        const SITE = "STARTOFGLOW";
        const path = location.pathname;
        const dedupeKey = `nxa:${SITE}${path}`;
        const now = Date.now();
        const last = Number(localStorage.getItem(dedupeKey) || 0);
        if (!last || now - last > 30 * 60 * 1000) {
          localStorage.setItem(dedupeKey, String(now));
          let sessionId = localStorage.getItem("nxa:sid");
          if (!sessionId) {
            sessionId = crypto.randomUUID();
            localStorage.setItem("nxa:sid", sessionId);
          }
          const q = new URLSearchParams(location.search);
          navigator.sendBeacon(
            "https://app.electricity.studio/api/marketing/analytics/track",
            JSON.stringify({
              site: SITE,
              path,
              referrer: document.referrer || "",
              userAgent: navigator.userAgent,
              sessionId,
              utmSource: q.get("utm_source") || "",
              utmMedium: q.get("utm_medium") || "",
              utmCampaign: q.get("utm_campaign") || "",
            }),
          );
        }
      } catch {
        /* tracking must never break the page */
      }
    